import React, { useContext } from 'react'
import { FormTextField } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'
import { Separator } from '@fs/zion-ui'
import { FieldNames } from '../constants'
import ForgotUsernamePasswordLink from './ForgotUsernamePasswordLink'
import { LiteContext } from '../context'

const FormUsernamePassword = ({ link, autoFocus = false }) => {
  const { t } = useTranslation()
  const isLite = useContext(LiteContext)
  // Rolling this back while figuring out why 1Password is not working with the new label
  // const hasFamilySearchUsernameLabel = !!i18n.getResource(i18n.language, 'translation', 'fs-username.label')
  // const FamilySearchUsernameLabel = hasFamilySearchUsernameLabel
  //   ? t('fs-username.label', 'FamilySearch Username')
  //   : t('common-ui:username.label', 'Username')
  return (
    <>
      <FormTextField
        id="userName"
        autoComplete="username"
        name={FieldNames.USERNAME}
        label={t('common-ui:username.label', 'Username')}
        placeholder={
          link
            ? t('fs-username.placeholder', 'Enter FamilySearch username')
            : t('username.placeholder', 'Enter username')
        }
        autoFocus={autoFocus}
        autoCapitalize="off"
      />
      <FormTextField
        type="password"
        id="password"
        autoComplete="current-password"
        name={FieldNames.CURRENT_PASSWORD}
        label={t('password.label', 'Password')}
        placeholder={
          link
            ? t('fs-password.placeholder', 'Enter FamilySearch password')
            : t('password.placeholder', 'Enter password')
        }
        autoCapitalize="off"
      />
      <ForgotUsernamePasswordLink />
      {!isLite ? <Separator size="lg" /> : <Separator />}
    </>
  )
}

export default FormUsernamePassword
